import { render, staticRenderFns } from "./ProfileWelcome.vue?vue&type=template&id=017282f4&scoped=true&"
import script from "./ProfileWelcome.vue?vue&type=script&lang=js&"
export * from "./ProfileWelcome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "017282f4",
  null
  
)

export default component.exports